var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count)?_c('div',{staticClass:"rating"},[_vm._l((_vm.stars),function(star,index){return _c('i',{key:index,class:star,attrs:{"aria-hidden":"true"}})}),_c('span',{staticClass:"count"},[_vm._v("("+_vm._s(_vm.count)+")")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }